// Configuration for backend URLs
export const config = {
  // Set this to true to use local backend, false for AWS backend
  // In production, this should always be false
  usingLocalBackend: false,

  // Backend URLs
  awsBackendUrl: 'https://pag3vhxg6ny5pobomcsk2bxwpy0sjmuo.lambda-url.eu-north-1.on.aws',
  localBackendUrl: 'http://127.0.0.1:8000',

  // Get the current backend URL based on configuration
  getBackendUrl: function () {
    return this.usingLocalBackend ? this.localBackendUrl : this.awsBackendUrl
  },
}
